import { GridColDef } from "@mui/x-data-grid-premium";
import { IconButton, Stack } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import RevisedTraumaScoreRows from "../model";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { useState } from "react";
import RevisedTraumaScoreCreate from "../create";
import { useTranslate } from "src/locales";
import btListImage from '../assets/btListImage.png'
import BaseMedCardList from "src/components/shared-components/medcard/BaseMedCardList";

function RevisedTraumaScoreList() {
  const [open, setOpen] = useState(false);
  const { t } = useTranslate();

  //AOZMEN;452648;25032025
  const revisedTraumaColumns: GridColDef[] = [
    {
      field: "update",
      headerName: "Güncelle",
      width: 150,
      renderCell(params) {
        return (        
            <EditIcon onClick={()=> setOpen(true)} color="info" />
        );
      },
    },
    { field: "date", headerName: "Tarih", flex: 1 },
    { field: "field1", headerName: "Alan 1", flex: 1 },
    { field: "field2", headerName: "Alan 2", flex: 1 },
    { field: "field3", headerName: "Alan 3", flex: 1 },
    { field: "field4", headerName: "Alan 4", flex: 1 },
    { field: "field5", headerName: "Alan 5", flex: 1 },
    {
      field: "delete",
      headerName: "Sil",
      flex: 1,
      renderCell: (params) => (
        <IconButton onClick={() => console.log(params.row.id)}>
          <DeleteIcon color="error" />
        </IconButton>
      ),
    },
  ];

  return (
    <BaseMedCardList
      rows={RevisedTraumaScoreRows}
      columns={revisedTraumaColumns}
      CreateComponent={RevisedTraumaScoreCreate}
      title={t("revised-trauma-score.title")}
    >
      <Stack display={'flex'} direction={"row"} gap={2} >
          <img
             style={{ width: "auto", height: "auto" , display: "inline-block"}}
             src={btListImage}
             alt=""
          />  
      
          <ByzMuiTypography
            sx={{
              fontSize: 13,
              fontWeight: 500,
              lineHeight : '24px',
              textAlign : 'start',
              display:'inline-block',  
              wordWrap: "break-word",
              margin: 0,
              width : 455,
              height : 168,
              letterSpacing : 0.4
            }}
          >
            {t("revised-trauma-score.list-text")}
          </ByzMuiTypography>
        
      </Stack>
    </BaseMedCardList>
  );
}




export default RevisedTraumaScoreList;
